import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=0b0f0848&scoped=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=ts"
export * from "./SwitchToggle.vue?vue&type=script&lang=ts"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&id=0b0f0848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f0848",
  null
  
)

export default component.exports